// import React, { useEffect, useState } from 'react';
// import client from '../../sanity/client';
// import { useLanguage } from '../../components/LanguageContext';
// import { Link } from 'react-router-dom';
// import { PlusIcon, ArrowRight } from '../../assets/svg';
// import './Veilleuse.scss';

// const Parutions = () => {
//   const [data, setData] = useState(null);
//   const { language } = useLanguage();

//   useEffect(() => {
//     const fetchData = async () => {
//       const query = `*[_type == "poeteSectionParutions"][0]{
//         parutions[]{
//           _key,
//           title,
//           "slug": slug.current,
//           description,
//           image,
//           gallery[]{ "imageUrl": asset->url + "?auto=format" }
//         }
//       }`;
//       const result = await client.fetch(query);
//       setData(result);
//     };

//     fetchData();
//   }, []);

//   if (!data) return <div>Loading...</div>;

//   // Extrait les sections
//   const parutionsSection = data.parutions;

//   return (
//     <div className="oeuvre-page">
//       {/* Section Parutions */}
//       <section className="oeuvre-page" >
//         <h1>parutions</h1>
//         <div className="works-list">
//           {parutionsSection && parutionsSection.map((item) => (
//             <div key={item._key} className="work-item">
//               <Link to={`/poete/parutions/${item.slug}`} className="work-header hover-icon-transition">
//                 <h2>{item.title}</h2>
//                 <span className="icon-wrapper">
//                   <span className="plus-icon"><PlusIcon /></span>
//                   <span className="arrow-icon"><ArrowRight /></span>
//                 </span>
//               </Link>
//             </div>
//           ))}
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Parutions;
import React, { useEffect, useState } from 'react';
import client from '../../sanity/client';
import { useLanguage } from '../../components/LanguageContext';
import { PlusIcon, ArrowRight } from '../../assets/svg';
import useScrollPosition from '../../hooks/useScrollPosition';
import useSectionNavigation from '../../hooks/useSectionNavigation';
import './Veilleuse.scss';

const Parutions = () => {
  const [data, setData] = useState(null);
  const [sectionTitle, setSectionTitle] = useState(null);
  const { language } = useLanguage();
  
  // Hooks pour gérer la position de scroll et navigation
  useScrollPosition();
  const { navigateToDetail } = useSectionNavigation();

  useEffect(() => {
    const fetchData = async () => {
      // Récupère le document poeteSectionParutions avec les titres multilingues
      const query = `*[_type == "poeteSectionParutions"][0]{
        sectionTitle,
        parutions[]{
          _key,
          title,
          "slug": slug.current,
          description,
          link{
            url,
            text
          },
          image,
          gallery[]{ "imageUrl": asset->url + "?auto=format" }
        }
      }`;
      const result = await client.fetch(query);
      setData(result);
      setSectionTitle(result?.sectionTitle);
    };

    fetchData();
  }, []);

  // Fonction helper pour gérer les titres multilingues
  const getSafeTitle = (titleObj) => {
    if (!titleObj) return 'Titre par défaut';
    if (typeof titleObj === 'string') return titleObj; // Compatibilité ancien format
    return titleObj[language] || titleObj.fr || titleObj.en || 'Titre';
  };

  if (!data) return <div>Loading...</div>;

  // Extrait les sections
  const parutionsSection = data.parutions;

  return (
    <div className="oeuvre-page">
      {/* Section Parutions */}
      <section id="parutions">
        {/* <h1>
          {sectionTitle?.[language] || sectionTitle?.fr || sectionTitle?.en || 'parutions'}
        </h1> */}
        <div className="works-list">
          {parutionsSection && parutionsSection.map((item) => (
            <div key={item._key} className="work-item">
              <a 
                href="#"
                className="work-header hover-icon-transition"
                onClick={(e) => {
                  e.preventDefault();
                  navigateToDetail(`/veilleusedelieux/parutions/${item.slug}`, 'parutions');
                }}
              >
                <h2>{getSafeTitle(item.title)}</h2>
                <span className="icon-wrapper">
                  <span className="plus-icon"><PlusIcon /></span>
                  <span className="arrow-icon"><ArrowRight /></span>
                </span>
              </a>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Parutions;
